export const allowedLanguages = ['en', 'de', 'es'] as const;
export type TLanguages = typeof allowedLanguages[number];
export const languageDefault: TLanguages = allowedLanguages[0];
export const languageRegex = allowedLanguages.join('|');
